import Grid from '@material-ui/core/Grid';
import Tooltip from '@material-ui/core/Tooltip';
import Typography from '@material-ui/core/Typography';
import clsx from 'clsx';
import LinkComp from 'components/atoms/LinkComp';
import { PRODUCTS_LOADING_URL } from 'constants/Paths';
import gtag from 'utils/gtag';
import ImageFallback from 'utils/ImageFallback';
import useMobileV2 from 'zustand-lib/storeMobile';
import styles from './tag.module.css';

const getUrlTag = ({ slug, url, code }) => {
  // TODO: url maybe is []string in useDealTagUrl
  if (url) {
    if (Array.isArray(url)) {
      return url.join();
    } else {
      return url;
    }
  }
  if (slug) return `/tag/${slug}`;
  return `${PRODUCTS_LOADING_URL}?tag=${code}`;
};

export default function ProductTag({
  name,
  preIcon,
  Icon = null,
  nameAsTooltip,
  textColor,
  style,
  styleName,
  code,
  backgroundColor,
  date,
  isTooltip = false,
  url = null,
  borderColor,
  isStyleV2 = false,
  slug,
  link,
  isLinkTagDeal,
  isProductDetailPage = false,
  horizontalIconSvg = "", // force for hang hang tag
  isHangDiemStore = false, // special case for "hang diem' store
  hangDiemLink = "", // force redirect to hang diem store
}) {
  const isMobileV2 = useMobileV2((state) => state.isMobileV2());
  // TODO: special case, only display tag dynamic in product detail page for "hang diem" store
  if (isHangDiemStore && code === "2ABC") {
    // remove redirect link for this case
    if (isProductDetailPage) {
      return (
        <LinkComp stopProp removeStyles href={hangDiemLink} data-tag={`tags-${code}`}>
          <div className="relative min-w-[92px] h-[24px]" onClick={() => gtag.clickTagInProduct(name)}>
            <ImageFallback src={(horizontalIconSvg)} objectFit="cover" layout="fill" alt="tag hang hang" />
          </div>
        </LinkComp>
      );
    }
    return (
      <LinkComp stopProp removeStyles href={hangDiemLink} data-test={`tags-${code}`}>
        <Tooltip title={name || ''}>
          <Grid
            style={{
              borderColor: borderColor || backgroundColor,
              color: textColor,
              backgroundColor,
              ...(style || {}),
            }}
            className={clsx({
              [styles.icon_tag_container]: !isStyleV2,
              [styles.tag_containerv2]: isStyleV2,
            })}
            onClick={() => {
              gtag.clickTagInProduct(name);
            }}
          >
            {Icon && Icon}
          </Grid>
        </Tooltip>
      </LinkComp>
    )
  }
  // parse preIcon
  if (preIcon) {
    if (typeof preIcon === 'string') {
      if (preIcon.indexOf(' ') > 0) {
        preIcon = preIcon.split(' ');
      }
    } else if (typeof preIcon === 'object' && preIcon.value) {
      preIcon = preIcon.value;
    }
  }
  // capitalize
  name = name
    ?.split(' ')
    ?.map((word) => (word.length > 1 ? word.charAt(0).toUpperCase() + word.substr(1) : word.toUpperCase()))
    ?.join(' ');

  if (isTooltip && (Icon || preIcon)) {
    const urlTag = getUrlTag({ code, url: code === 'DEAL' && isLinkTagDeal ? link : url, slug });

    return (
      <LinkComp stopProp removeStyles href={urlTag} data-test={`tags-${code}`}>
        <Tooltip title={name || ''}>
          <Grid
            style={{
              borderColor: borderColor || backgroundColor,
              color: textColor,
              backgroundColor,
              ...(style || {}),
            }}
            // className={isStyleV2 ? styles.tag_containerv2 : styles.icon_tag_container}
            className={clsx({
              [styles.icon_tag_container]: !isStyleV2,
              [styles.tag_containerv2]: isStyleV2,
              [styles.tag_container_mobilev2]: isMobileV2,
            })}
            onClick={() => {
              gtag.clickTagInProduct(name);
            }}
          >
            {Icon && Icon}
          </Grid>
        </Tooltip>
      </LinkComp>
    );
  }

  // normal display
  if (!nameAsTooltip && name) {
    const urlTag = getUrlTag({ code, url: code === 'DEAL' && isLinkTagDeal ? link : url, slug });

    return (
      <LinkComp stopProp removeStyles href={urlTag} data-test={`tags-${code}`}>
        <Grid
          style={{
            borderColor: borderColor || backgroundColor,
            color: textColor,
            backgroundColor,
            ...(style || {}),
          }}
          // className={clsx(isStyleV2 ? styles.tag_containerv2 : styles.tag_container, date ? styles.date_tag_container : styles.normal_tag_container)}
          className={clsx({
            [styles.tag_container]: !isStyleV2,
            [styles.tag_containerv2]: isStyleV2,
            [styles.normal_tag_container]: !date,
            [styles.date_tag_container]: date,
            [styles.tag_container_mobilev2]: isMobileV2,
          })}
          onClick={() => {
            gtag.clickTagInProduct(name);
          }}
        >
          {Icon && Icon}
          <Typography
            className={clsx({
              [styles.nameTag]: true,
              [styles.nameTagMobileV2]: isMobileV2,
            })}
            style={{ ...(styleName || {}) }}
          >
            {name}
          </Typography>
        </Grid>
      </LinkComp>
    );
  }

  // quick order display
  return (
    <>
      {preIcon && name && (
        <Tooltip title={name}>
          <div
            style={{
              borderColor: borderColor || backgroundColor,
              color: textColor,
              backgroundColor,
              ...(style || {}),
            }}
            className={isStyleV2 ? styles.tag_containerv2 : styles.tag_container}
            data="no link"
          >
            {Icon && Icon}
          </div>
        </Tooltip>
      )}
    </>
  );
}
